import React, { useState } from 'react';
import {
    Box,
    TextField,
    Button,
    Typography,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from '@mui/material';

const DeleteAccount = () => {
    const [phoneNumber, setPhoneNumber] = useState('');
    const [open, setOpen] = useState(false);

    // Handles form submission
    const handleSubmit = () => {
        if (phoneNumber.trim() !== '') {
            setOpen(true); // Show the popup dialog
        } else {
            alert('Please enter a valid phone number.');
        }
    };

    // Handles closing the dialog
    const handleClose = () => {
        setOpen(false); // Close the dialog
        window.location.reload(); // Refresh the page
    };

    return (
        <Box
            sx={{
                padding: 4,
                maxWidth: 400,
                margin: 'auto',
                textAlign: 'center',
            }}
        >
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold' }}>
                Delete Your Account
            </Typography>
            <Typography variant="body2" color="textSecondary" mb={2}>
                Enter your phone number to delete your account.
            </Typography>

            <TextField
                fullWidth
                label="Phone Number"
                variant="outlined"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                margin="normal"
                inputProps={{ maxLength: 10 }} // Restrict input length
            />

            <Button
                variant="contained"
                color="error"
                onClick={handleSubmit}
                sx={{ marginTop: 2 }}
            >
                Submit
            </Button>
            <div style={{ marginTop: 10 }}></div>
            <Typography variant="p" gutterBottom sx={{ fontWeight: 'normal', fontSize: 15, fontStyle: 'italic' }}>
                <b>Please Note: </b> Once submitted your account will be auto-deleted after 30 days if you do not log-in back!
            </Typography>

            {/* Dialog Pop-up */}
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Account Deletion</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Your account associated with phone number <b>{phoneNumber} </b>
                        will be deleted in 30 days if you do not log in again.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default DeleteAccount;
